import React, { useState, useContext, useEffect } from 'react';
import MultiEditingTextBoxAttribute from './TextBoxControlAttribute'
import MultiEditingCalendarAttribute from './CalendarControlAttribute'
import MultiEditingFontFamilyAttribute from './FontFamilyControlAttribute';
import MultiEditingImageAttribute from './ImageControlAttribute';
import {IMultiEditingPickerAttribute} from '../types'
import ColorPickerControlAttribute from './ColorPickerControlAttribute'
import {IUserConfig} from '@state/userConfig/types';
import { useSelector, useDispatch } from 'react-redux';
import selectors from '@state/selectors';

const MultiEditingAttributes:React.FC<IMultiEditingPickerAttribute> = (props) => {
    const userConfig: IUserConfig|undefined = useSelector(selectors.userConfig.getUserConfig);

    return (
      <>
        {
            props.control==="TEXTBOX" && 
            <MultiEditingTextBoxAttribute categoryId={props.categoryId} fieldId={props.fieldId} elementType={props.elementType} selectDescribeFieldId={props.selectDescribeFieldId} name={props.name} dataType={props.dataType} validation={props.validation} formating={props.formating}/>
        }
        {
            props.control==="CALENDAR" && 
            <MultiEditingCalendarAttribute categoryId={props.categoryId} fieldId={props.fieldId} elementType={props.elementType} selectDescribeFieldId={props.selectDescribeFieldId} name={props.name} dataType={props.dataType} validation={props.validation} formating={props.formating}/>
        }
        {
            (props.control==="COLORPICKER" && ((userConfig?.multiEditor?.showColors && props.elementType==="Text") || props.elementType!=="Text" )) && 
            <ColorPickerControlAttribute categoryId={props.categoryId} fieldId={props.fieldId} elementType={props.elementType} selectDescribeFieldId={props.selectDescribeFieldId} name={props.name} label={props.label} dataType={props.dataType}/>
        }
        {
            (props.control==="DROPDOWN" && userConfig?.multiEditor?.showFonts && props.elementType==="Text") &&
            <MultiEditingFontFamilyAttribute categoryId={props.categoryId} fieldId={props.fieldId} elementType={props.elementType} selectDescribeFieldId={props.selectDescribeFieldId} name={props.name} dataType={props.dataType} validation={props.validation} formating={props.formating}/>
        }
        {
            props.control==="IMAGEPICKER" && 
            <MultiEditingImageAttribute categoryId={props.categoryId} categoryName={props.categoryName} fieldId={props.fieldId} elementType={props.elementType} selectDescribeFieldId={props.selectDescribeFieldId} name={props.name} dataType={props.dataType} validation={props.validation} formating={props.formating}/>
        }
      </>
  );
}

export default MultiEditingAttributes;